import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  ru: {
    // Nav
    nav_home: 'Главная',
    nav_program: 'Программа курса',
    nav_map: 'Карта проекта',
    nav_gosts: 'ГОСТы',
    nav_tasks: 'Задания',
    nav_contacts: 'Контакты',
    nav_title: 'ГУАП | Проектное управление',
    nav_slogan: 'Учись. Изобретай. Живи.',

    // Hero
    hero_title1: 'Управляй',
    hero_title2: 'Созданием',
    hero_title3: 'Будущего.',
    hero_sub: 'Навыки проектного управления помогают не только успешно реализовывать проекты, но и выстраивать карьерный путь и траекторию саморазвития.',
    hero_cta1: 'Начать обучение',
    hero_cta2: 'Программа курса',
    stat1: '5 разделов',
    stat2: '5 практических заданий',
    stat3: '1 готовый проект',
    stat4: 'ГОСТ Р 54869-2011',

    // About
    about_title: 'О курсе',
    about_desc: 'Курс разработан для освоения базовых знаний и инструментов проектного управления.',
    about_mission: '«Подготовка профессиональных кадров для высокотехнологичной индустрии, способных разрабатывать и внедрять передовые технологии»',
    feature1_title: 'Соответствие ГОСТ',
    feature1_desc: 'Полное соответствие ГОСТ Р 54869-2011, 54870-2011, 54871-2011 и ИСО 21500',
    feature2_title: 'Практические задания',
    feature2_desc: '5 практических заданий с реальными документами проектного управления',
    feature3_title: 'Реальный проект',
    feature3_desc: 'На выходе — полный комплект проектной документации собственного проекта',
    about_support: 'Курс разработан при поддержке ГУАП — Санкт-Петербургского государственного университета аэрокосмического приборостроения',

    // Map
    map_title: 'Карта жизненного цикла проекта',
    map_sub: 'Интерактивная диаграмма по ГОСТ Р 54869-2011. Нажмите на этап для подробностей.',
    map_stage1: 'Инициация',
    map_stage1_ref: 'п. 5.2 ГОСТ Р 54869-2011',
    map_stage1_desc: 'Формирование концепции проекта, определение целей, назначение руководителя проекта. Разработка Паспорта/Устава проекта.',
    map_stage1_out: 'Паспорт проекта, Устав проекта',
    map_stage2: 'Планирование',
    map_stage2_ref: 'п. 5.3 ГОСТ Р 54869-2011',
    map_stage2_desc: 'Детальная разработка планов по всем аспектам проекта: содержание, расписание, бюджет, персонал, риски, коммуникации.',
    map_stage2_out: 'ИСР, Календарный план, Бюджет, Матрица ответственности, Реестр рисков',
    map_stage3: 'Исполнение',
    map_stage3_ref: 'п. 5.4 ГОСТ Р 54869-2011',
    map_stage3_desc: 'Организация и координация выполнения работ по проекту в соответствии с утверждёнными планами.',
    map_stage3_out: 'Результаты работ, Отчёты об исполнении',
    map_stage4: 'Контроль',
    map_stage4_ref: 'п. 5.5 ГОСТ Р 54869-2011',
    map_stage4_desc: 'Мониторинг хода исполнения проекта, анализ отклонений, разработка и реализация корректирующих действий.',
    map_stage4_out: 'Запросы на изменение, Отчёты о состоянии',
    map_stage5: 'Завершение',
    map_stage5_ref: 'п. 5.6 ГОСТ Р 54869-2011',
    map_stage5_desc: 'Формальное закрытие проекта: приёмка результатов, архивирование, анализ накопленного опыта.',
    map_stage5_out: 'Акт приёмки, Архив проекта, Анализ опыта',
    map_outputs: 'Выходы:',
    map_substages: 'Подпроцессы:',
    map_sub21: 'Планирование содержания — ИСР',
    map_sub22: 'Разработка расписания — Календарный план',
    map_sub23: 'Планирование бюджета — Бюджет',
    map_sub24: 'Планирование персонала — Матрица ответственности',
    map_sub25: 'Планирование рисков — Реестр рисков',
    map_sub26: 'Планирование коммуникаций — Схема коммуникаций',
    map_click_detail: 'Нажмите для деталей',
    map_go_section: 'Перейти к разделу курса',

    // Program
    program_title: 'Программа курса',
    program_sub: 'Структурированный курс по управлению проектами в соответствии с ГОСТ Р 54869-2011',
    program_task: 'Задание',
    sec1_title: 'Раздел 1: Что такое проект?',
    sec1_t1: 'Определение проекта по ГОСТ',
    sec1_t2: 'Отличие проекта от процесса',
    sec1_t3: 'Продукт и заинтересованные стороны',
    sec1_task: 'Задание 1: Идея проекта и карточка стейкхолдеров',
    sec2_title: 'Раздел 2: Инициация проекта',
    sec2_t1: 'Процесс инициации (п. 5.2 ГОСТ)',
    sec2_t2: 'Паспорт и Устав проекта',
    sec2_t3: 'Заинтересованные стороны',
    sec2_task: 'Задание 2: Паспорт проекта',
    sec3_title: 'Раздел 3: Планирование проекта',
    sec3_t1: 'Содержание и ИСР (п. 5.3.1)',
    sec3_t2: 'Календарное планирование (п. 5.3.2)',
    sec3_t3: 'Бюджетирование (п. 5.3.3)',
    sec3_t4: 'Персонал и коммуникации (пп. 5.3.4, 5.3.7)',
    sec3_t5: 'Управление рисками (п. 5.3.6)',
    sec3_task: 'Задание 3: Комплект планов проекта',
    sec4_title: 'Раздел 4: Управление изменениями',
    sec4_t1: 'Реестр рисков проекта',
    sec4_t2: 'Запросы на изменение',
    sec4_t3: 'Контроль изменений',
    sec4_task: 'Задание 4: Реестр рисков + форма запроса на изменение',
    sec5_title: 'Раздел 5: Реализация, контроль и закрытие',
    sec5_t1: 'Исполнение и контроль (пп. 5.4, 5.5)',
    sec5_t2: 'Завершение проекта (п. 5.6)',
    sec5_t3: 'Архивирование и анализ опыта',
    sec5_task: 'Задание 5: Итоговый пакет документов',

    // GOSTs
    gosts_title: 'ГОСТы и стандарты',
    gosts_sub: 'Нормативная база курса — отечественные и международные стандарты управления проектами',
    gost1_name: 'ГОСТ Р 54869-2011',
    gost1_full: 'Проектный менеджмент. Требования к управлению проектом',
    gost1_scope: 'Основной стандарт курса. Определяет требования к процессам управления проектом от инициации до закрытия.',
    gost2_name: 'ГОСТ Р 54870-2011',
    gost2_full: 'Проектный менеджмент. Требования к управлению портфелем проектов',
    gost2_scope: 'Устанавливает требования к управлению портфелем проектов организации.',
    gost3_name: 'ГОСТ Р 54871-2011',
    gost3_full: 'Проектный менеджмент. Требования к управлению программой',
    gost3_scope: 'Определяет требования к управлению программой — совокупностью взаимосвязанных проектов.',
    gost4_name: 'ИСО 21500:2012',
    gost4_full: 'Руководство по управлению проектами',
    gost4_scope: 'Международный стандарт, гармонизированный с ГОСТ Р 54869. Обеспечивает глобальный контекст.',
    gosts_key_points: 'Ключевые пункты',
    gosts_download: 'Скачать выдержки',
    gosts_scheme_title: 'Взаимосвязь стандартов',
    gosts_scheme_sub: 'Иерархия объектов управления в проектном менеджменте',

    // Tasks
    tasks_title: 'Практические задания',
    tasks_sub: 'Реальные документы, которые вы создадите в ходе курса',
    task1_title: 'Задание 1: Идея проекта',
    task1_desc: 'Карточка стейкхолдеров и описание идеи проекта',
    task2_title: 'Задание 2: Паспорт проекта',
    task2_desc: 'Полный паспорт проекта по форме ГОСТ Р 54869-2011',
    task3_title: 'Задание 3: Комплект планов',
    task3_desc: 'ИСР, Календарный план, Бюджет, Матрица ответственности, Реестр рисков',
    task4_title: 'Задание 4: Реестр рисков',
    task4_desc: 'Реестр рисков и форма запроса на изменение',
    task5_title: 'Задание 5: Итоговый пакет',
    task5_desc: 'Полный комплект проектной документации',
    tasks_view_example: 'Посмотреть пример',
    tasks_download: 'Скачать шаблон',

    // Contacts
    contacts_title: 'Контакты',
    contacts_sub: 'Санкт-Петербургский государственный университет аэрокосмического приборостроения',
    contacts_address: 'ул. Большая Морская, д. 67, Санкт-Петербург',
    contacts_email: 'info@guap.ru',
    contacts_phone: '+7 (812) 494-70-00',
    contacts_dept: 'Кафедра менеджмента',
    contacts_map_placeholder: 'Открыть карту',

    // CTA
    cta_title: 'Готов начать свой проект?',
    cta_sub: 'Запишись на курс и создай свою первую проектную документацию по ГОСТ',
    cta_btn: 'Начать обучение',

    // Footer
    footer_desc: 'Курс по управлению проектами на основе ГОСТ Р 54869-2011 для студентов ГУАП',
    footer_copyright: '© 2024 ГУАП. Санкт-Петербургский государственный университет аэрокосмического приборостроения',
    footer_nav: 'Навигация',
    footer_standards: 'Стандарты',
    footer_social: 'Социальные сети',
  },
  en: {
    nav_home: 'Home',
    nav_program: 'Course Program',
    nav_map: 'Project Map',
    nav_gosts: 'Standards',
    nav_tasks: 'Assignments',
    nav_contacts: 'Contacts',
    nav_title: 'SUAI | Project Management',
    nav_slogan: 'Learn. Invent. Live.',

    hero_title1: 'Manage Projects',
    hero_title2: 'by GOST Standard.',
    hero_title3: 'Build the Future.',
    hero_sub: 'A practical project management course for SUAI students. Master GOST R 54869-2011, 54870-2011, 54871-2011 and ISO 21500 — and build your first real project.',
    hero_cta1: 'Start Learning',
    hero_cta2: 'Course Program',
    stat1: '3 modules',
    stat2: '5 practical tasks',
    stat3: '1 ready project',
    stat4: 'GOST R 54869-2011',

    about_title: 'About the Course',
    about_desc: 'The course is designed for SUAI students to master practical project management skills in accordance with Russian and international standards.',
    about_mission: '"Training professionals for high-tech industry capable of developing and implementing advanced technologies"',
    feature1_title: 'GOST Compliance',
    feature1_desc: 'Full compliance with GOST R 54869-2011, 54870-2011, 54871-2011 and ISO 21500',
    feature2_title: 'Practical Assignments',
    feature2_desc: '5 practical tasks with real project management documents',
    feature3_title: 'Real Project',
    feature3_desc: 'You get a full set of project documentation for your own project',
    about_support: 'Course developed with support of SUAI — Saint Petersburg State University of Aerospace Instrumentation',

    map_title: 'Project Lifecycle Map',
    map_sub: 'Interactive diagram based on GOST R 54869-2011. Click a stage for details.',
    map_stage1: 'Initiation',
    map_stage1_ref: 'Cl. 5.2 GOST R 54869-2011',
    map_stage1_desc: 'Concept formation, goal definition, appointing a project manager. Development of the Project Charter.',
    map_stage1_out: 'Project Passport, Project Charter',
    map_stage2: 'Planning',
    map_stage2_ref: 'Cl. 5.3 GOST R 54869-2011',
    map_stage2_desc: 'Detailed planning across all aspects: scope, schedule, budget, personnel, risks, communications.',
    map_stage2_out: 'WBS, Schedule, Budget, RACI matrix, Risk Register',
    map_stage3: 'Execution',
    map_stage3_ref: 'Cl. 5.4 GOST R 54869-2011',
    map_stage3_desc: 'Organizing and coordinating project work in accordance with approved plans.',
    map_stage3_out: 'Deliverables, Performance Reports',
    map_stage4: 'Monitoring',
    map_stage4_ref: 'Cl. 5.5 GOST R 54869-2011',
    map_stage4_desc: 'Monitoring project progress, analyzing deviations, developing corrective actions.',
    map_stage4_out: 'Change Requests, Status Reports',
    map_stage5: 'Closure',
    map_stage5_ref: 'Cl. 5.6 GOST R 54869-2011',
    map_stage5_desc: 'Formal project closure: acceptance of results, archiving, lessons learned.',
    map_stage5_out: 'Acceptance Act, Project Archive, Lessons Learned',
    map_outputs: 'Outputs:',
    map_substages: 'Sub-processes:',
    map_sub21: 'Scope Planning — WBS',
    map_sub22: 'Schedule Development — Timeline',
    map_sub23: 'Budget Planning — Budget',
    map_sub24: 'Personnel Planning — RACI matrix',
    map_sub25: 'Risk Planning — Risk Register',
    map_sub26: 'Communications Planning — Comm. Plan',
    map_click_detail: 'Click for details',
    map_go_section: 'Go to course section',

    program_title: 'Course Program',
    program_sub: 'Structured project management course based on GOST R 54869-2011',
    program_task: 'Assignment',
    sec1_title: 'Module 1: What is a Project?',
    sec1_t1: 'Project definition per GOST',
    sec1_t2: 'Project vs. process',
    sec1_t3: 'Product and stakeholders',
    sec1_task: 'Task 1: Project idea and stakeholder card',
    sec2_title: 'Module 2: Project Initiation',
    sec2_t1: 'Initiation process (Cl. 5.2)',
    sec2_t2: 'Project Passport and Charter',
    sec2_t3: 'Stakeholder analysis',
    sec2_task: 'Task 2: Project Passport',
    sec3_title: 'Module 3: Project Planning',
    sec3_t1: 'Scope and WBS (Cl. 5.3.1)',
    sec3_t2: 'Schedule planning (Cl. 5.3.2)',
    sec3_t3: 'Budgeting (Cl. 5.3.3)',
    sec3_t4: 'Personnel & communications (Cl. 5.3.4, 5.3.7)',
    sec3_t5: 'Risk management (Cl. 5.3.6)',
    sec3_task: 'Task 3: Project plans package',
    sec4_title: 'Module 4: Change Management',
    sec4_t1: 'Project risk register',
    sec4_t2: 'Change requests',
    sec4_t3: 'Change control',
    sec4_task: 'Task 4: Risk register + Change request form',
    sec5_title: 'Module 5: Execution, Control & Closure',
    sec5_t1: 'Execution and monitoring (Cl. 5.4, 5.5)',
    sec5_t2: 'Project closure (Cl. 5.6)',
    sec5_t3: 'Archiving and lessons learned',
    sec5_task: 'Task 5: Final documentation package',

    gosts_title: 'Standards & References',
    gosts_sub: 'Regulatory basis of the course — Russian and international project management standards',
    gost1_name: 'GOST R 54869-2011',
    gost1_full: 'Project Management. Requirements for Project Management',
    gost1_scope: 'The main standard of the course. Defines requirements for project management processes from initiation to closure.',
    gost2_name: 'GOST R 54870-2011',
    gost2_full: 'Project Management. Requirements for Portfolio Management',
    gost2_scope: 'Establishes requirements for managing an organization\'s project portfolio.',
    gost3_name: 'GOST R 54871-2011',
    gost3_full: 'Project Management. Requirements for Program Management',
    gost3_scope: 'Defines requirements for managing a program — a set of interrelated projects.',
    gost4_name: 'ISO 21500:2012',
    gost4_full: 'Guidance on Project Management',
    gost4_scope: 'International standard harmonized with GOST R 54869. Provides global context.',
    gosts_key_points: 'Key Clauses',
    gosts_download: 'Download excerpts',
    gosts_scheme_title: 'Standards Relationship',
    gosts_scheme_sub: 'Hierarchy of project management objects',

    tasks_title: 'Practical Assignments',
    tasks_sub: 'Real documents you will create during the course',
    task1_title: 'Task 1: Project Idea',
    task1_desc: 'Stakeholder card and project idea description',
    task2_title: 'Task 2: Project Passport',
    task2_desc: 'Full project passport per GOST R 54869-2011',
    task3_title: 'Task 3: Plans Package',
    task3_desc: 'WBS, Schedule, Budget, RACI matrix, Risk Register',
    task4_title: 'Task 4: Risk Register',
    task4_desc: 'Risk register and change request form',
    task5_title: 'Task 5: Final Package',
    task5_desc: 'Complete project documentation set',
    tasks_view_example: 'View Example',
    tasks_download: 'Download Template',

    contacts_title: 'Contacts',
    contacts_sub: 'Saint Petersburg State University of Aerospace Instrumentation',
    contacts_address: '67 Bolshaya Morskaya St., Saint Petersburg',
    contacts_email: 'info@guap.ru',
    contacts_phone: '+7 (812) 494-70-00',
    contacts_dept: 'Department of Management',
    contacts_map_placeholder: 'Open Map',

    cta_title: 'Ready to start your project?',
    cta_sub: 'Enroll in the course and create your first project documentation per GOST',
    cta_btn: 'Start Learning',

    footer_desc: 'Project management course based on GOST R 54869-2011 for SUAI students',
    footer_copyright: '© 2024 SUAI. Saint Petersburg State University of Aerospace Instrumentation',
    footer_nav: 'Navigation',
    footer_standards: 'Standards',
    footer_social: 'Social Media',
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('ru');
  const t = (key) => translations[lang][key] || key;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
